import { useState } from 'react'

import {
  Container,
  Grid,
  makeStyles,
  Box,
  Button,
  Typography,
  Divider,
  TextField,
  Chip,
} from '@material-ui/core'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'

import { ContentHeader, Page } from 'components'
import useFetch from 'hooks/useFetch'
import useSnackbar from 'hooks/useSnackbar'
import { ListDocuments } from './components'
import { useParams } from 'react-router-dom'

import styles from './styles'
import * as service from 'service'
import { routes } from 'Routes'
import helpers from 'helpers'

const useStyles = makeStyles(styles)

const AccountsShow = () => {
  const classes = useStyles()
  const snackbar = useSnackbar()
  const { accountId } = useParams()
  {
    console.log(accountId)
  }
  const [open, setOpen] = useState(false)
  const [reprovalReason, setReprovalReason] = useState('')

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    setReprovalReason('')
  }

  const { response, isLoading } = useFetch(
    service.intermediador.accounts.show,
    accountId,
    [accountId],
  )

  {
    console.log(response)
  }

  const approve = async () => {
    try {
      await service.intermediador.accounts.approve(accountId)
      snackbar.open({
        variant: 'success',
        message: 'Conta aprovada com sucesso',
      })
      // Recarrega os dados sem redirecionar
      window.location.href = window.location.href
    } catch (error) {
      snackbar.open({
        variant: 'error',
        message: 'Erro ao aprovar conta',
      })
    }
  }

  const reprove = () => {
    handleClickOpen()
  }

  const handleRefuse = async () => {
    try {
      await service.intermediador.accounts.refuse(accountId, reprovalReason)
      snackbar.open({
        variant: 'success',
        message: 'Conta reprovada com sucesso',
      })
      handleClose()
      // Recarrega os dados sem redirecionar
      window.location.href = window.location.href
    } catch (error) {
      snackbar.open({
        variant: 'error',
        message: 'Erro ao reprovar conta',
      })
    }
  }

  return (
    <Page title="Cliente">
      <Container maxWidth={false} className={classes.rootNew}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <ContentHeader
              menu="Clientes"
              title="visualizar"
              subtitle="Cliente"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Box display="flex" direction="row">
              {response?.data?.account?.status !== 'approved' && (
                <Box mr={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={approve}
                  >
                    Aprovar
                  </Button>
                </Box>
              )}
              <Box mr={2}>
                <Button
                  variant="contained"
                  color="warning"
                  size="small"
                  onClick={reprove}
                >
                  Reprovar
                </Button>
              </Box>
              <Box>
                <Button
                  variant="outlined"
                  color="primary"
                  size="small"
                  onClick={() =>
                    (window.location.href = routes.accounts.edit.replace(
                      ':accountId',
                      accountId,
                    ))
                  }
                >
                  Editar
                </Button>
              </Box>
            </Box>
          </Grid>

          {/* DADOS PESSOAIS */}
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography color="textPrimary" variant="h6">
              Dados Pessoais
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              Nome
            </Typography>
            <Typography color="textPrimary" variant="body1">
              {response?.data?.account?.name || '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              CPF
            </Typography>
            <Typography color="textPrimary" variant="body1">
              {response?.data?.account?.user?.document?.value || '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              E-mail
            </Typography>
            <Typography color="textPrimary" variant="body1">
              {response?.data?.account?.user?.email || '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              Status
            </Typography>
            <Chip
              label={
                helpers.accounts.statusLabel(response?.data?.account?.status) ||
                '-'
              }
              size="small"
            />
          </Grid>

          {/* DADOS DO USUÁRIO RESPONSÁVEL */}
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography color="textPrimary" variant="h6">
              Dados do Usuário Responsável
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              Nome do Responsável
            </Typography>
            <Typography color="textPrimary" variant="body1">
              {response?.data?.account?.user?.name || '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              RG
            </Typography>
            <Typography color="textPrimary" variant="body1">
              {response?.data?.account?.user?.rg || '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              Telefone Celular
            </Typography>
            <Typography color="textPrimary" variant="body1">
              {response?.data?.account?.user?.celphone || '-'}
            </Typography>
          </Grid>

          {/* DADOS EMPRESARIAIS */}
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography color="textPrimary" variant="h6">
              Dados Empresariais
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              CNPJ
            </Typography>
            <Typography color="textPrimary" variant="body1">
              {response?.data?.account?.cnpj || '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              Razão Social
            </Typography>
            <Typography color="textPrimary" variant="body1">
              {response?.data?.account?.companyName || '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              Nome Fantasia
            </Typography>
            <Typography color="textPrimary" variant="body1">
              {response?.data?.account?.fantasyName || '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              E-mail Institucional
            </Typography>
            <Typography color="textPrimary" variant="body1">
              {response?.data?.account?.institutionalEmail || '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              URL
            </Typography>
            <Typography color="textPrimary" variant="body1">
              {response?.data?.account?.url || '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              Categoria do Negócio
            </Typography>
            <Typography color="textPrimary" variant="body1">
              {response?.data?.account?.businessCategory || '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              Faixa de Faturamento Mensal
            </Typography>
            <Typography color="textPrimary" variant="body1">
              {response?.data?.account?.monthlyBillingRange || '-'}
            </Typography>
          </Grid>

          {/* LOCALIZAÇÃO */}
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography color="textPrimary" variant="h6">
              Localização
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              CEP
            </Typography>
            <Typography color="textPrimary" variant="body1">
              {response?.data?.account?.accountAddress?.cep || '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              Estado
            </Typography>
            <Typography color="textPrimary" variant="body1">
              {response?.data?.account?.accountAddress?.state || '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              Cidade
            </Typography>
            <Typography color="textPrimary" variant="body1">
              {response?.data?.account?.accountAddress?.city || '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              Bairro
            </Typography>
            <Typography color="textPrimary" variant="body1">
              {response?.data?.account?.accountAddress?.neighborhood || '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              Rua
            </Typography>
            <Typography color="textPrimary" variant="body1">
              {response?.data?.account?.accountAddress?.street || '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              Número
            </Typography>
            <Typography color="textPrimary" variant="body1">
              {response?.data?.account?.accountAddress?.number || '-'}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={4}>
            <Typography color="textPrimary" variant="body2">
              Complemento
            </Typography>
            <Typography color="textPrimary" variant="body1">
              {response?.data?.account?.accountAddress?.complement || '-'}
            </Typography>
          </Grid>

          {/* DOCUMENTOS */}
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Divider />
          </Grid>
          {/* <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography color="textPrimary" variant="h6">
              Documentos
            </Typography>
          </Grid>
          <ListDocuments /> */}
        </Grid>
      </Container>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Reprovar conta</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Escreva o motivo da reprova para registros.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Motivo da reprova"
            type="text"
            fullWidth
            value={reprovalReason}
            onChange={(e) => setReprovalReason(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button
            onClick={handleRefuse}
            color="primary"
            disabled={!reprovalReason.trim()}
          >
            Reprovar
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  )
}

export default AccountsShow
